export default state => {
	return state.isError;
};
